import { render } from "./base-label.vue?vue&type=template&id=7ccfd61c&scoped=true&ts=true"
import script from "./base-label.vue?vue&type=script&lang=ts"
export * from "./base-label.vue?vue&type=script&lang=ts"

import "./base-label.vue?vue&type=style&index=0&id=7ccfd61c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccfd61c"]])

export default __exports__